import type { NewApptState } from '../types';

const selectSlotStreakIds = (state: NewApptState) => state.newAppt.slot.streakIds;

export { selectSlotStreakIds };
